import { TGetOrderResponse, TPageSettingsResponse } from '@p2p/services';
import {
  CHECKED_USER_LOCAL_STORAGE_KEY,
  UPLOADED_ORDER_LOCAL_STORAGE_KEY,
} from '@p2p/shared/constants';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { isProofRouteAllowed, resolveProofRoute } from './ProofPayment.utils';

const readLocalStorage = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const useProofPaymentNavigation = (
  order?: TGetOrderResponse,
  pageSettings?: TPageSettingsResponse,
  isFetching?: boolean,
) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!order || !pageSettings || isFetching) return;

    const target = resolveProofRoute({
      order,
      pageSettings,
      isCheckedUser: readLocalStorage(CHECKED_USER_LOCAL_STORAGE_KEY) === order.id,
      isReceiptSent: readLocalStorage(UPLOADED_ORDER_LOCAL_STORAGE_KEY) === order.id,
    });

    if (!isProofRouteAllowed(pathname, target, order.id)) {
      // replace: кнопка «Назад» не должна возвращать на экран, с которого увели.
      navigate(target, { replace: true });
    }
  }, [navigate, order, pageSettings, isFetching, pathname]);
};
